const translations = {
  'contacto.seo.title':
    '¿Estás pensando en dar clases de inglés en Barcelona o Sevilla? Contáctanos',
  'contacto.seo.description': `¿Estás pensando dar clases de inglés en Barcelona o Sevilla? Pónte en contacto con nosotros para obtener más información y te responderemos en menos de 24 horas.`,
  'contacto.sec1.title': 'Contacto',
  'contacto.sec1.description': 'Contáctanos y te responderemos en 24 horas',

  'contacto.sec2.form': 'Envíanos un mensaje',
  'contacto.sec2.firstName': 'Nombre',
  'contacto.sec2.lastName': 'Apellido',
  'contacto.sec2.email': 'Email',
  'contacto.sec2.comment': 'Preguntas / Comentarios',
  'contacto.sec2.submit': 'Enviar',

  'contacto.sec2.text':
    'TEFL Iberia está ubicado en el centro del destacado barrio de Eixample, a dos minutos a pie de Paseo de Gracia y a diez minutos de Plaza Cataluña',
  'contacto.sec2.address': 'DIRECCIÓN:',
  'contacto.sec2.hours': 'HORARIO DE RECEPCIÓN:',
  'contacto.sec2.phone': 'TELÉFONO:',
  'contacto.sec2.whatsapp': 'WHATSAPP:',
  'contacto.sec2.email': 'EMAIL:',
};

export default translations;
